import React from 'react';
import { ButtonTabWrapper, RoundedButton } from './styled';
import pallet from '../../layouts/pallet';
import { ButtonTabSwitchProps } from './types';

const getButtonColors = (isActive: boolean) => ({
  backgroundColor: isActive ? pallet.primary : pallet.white,
  textColor: isActive ? pallet.white : pallet.formLabelText,
  boxShadow: isActive ? '0px 2px 4px 0px rgba(105, 108, 255, 0.4)' : 'none'
});

const ButtonTabSwitch = <T extends string | number>({
  tabs,
  activeTab,
  setActiveTab
}: ButtonTabSwitchProps<T>) => {
  return (
    <ButtonTabWrapper>
      {tabs.map(({ key, label, IconActive, IconInactive }) => {
        const isActive = activeTab === key;
        const Icon = isActive ? IconActive : IconInactive;
        const { backgroundColor, textColor, boxShadow } =
          getButtonColors(isActive);

        return (
          <RoundedButton
            key={String(key)}
            backgroundColor={backgroundColor}
            textColor={textColor}
            boxShadow={boxShadow}
            onClick={() => setActiveTab(key)}
          >
            {Icon && <Icon style={{ marginRight: '6px' }} />}
            {label}
          </RoundedButton>
        );
      })}
    </ButtonTabWrapper>
  );
};

export default ButtonTabSwitch;
